import React, { useState } from "react";
import NewHeader from "../components/NewHeader";
import NewSidebar from "../components/NewSidebar";
import NewFooter from "../components/NewFooter";
import { Outlet } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";
import { ToastContainer, Zoom } from "react-toastify";
import { useSelector } from "react-redux";

const NewDashboardLayout = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="new-dashboard-layout">
      <ScrollToTop />
      <ToastContainer
        position="top-right"
        autoClose={100}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        transition={Zoom}
        theme="light"
        toastClassName={({ type }) =>
          `relative flex justify-between items-center gap-2 shadow-xl rounded-xl p-4 ${
            type === "success"
              ? "bg-green-50 border-green-500 text-green-800"
              : "bg-red-50 border-red-500 text-red-800"
          }`
        }
        bodyClassName="text-lg font-large text-gray-800"
      />
{userInfo ? (
  <div className="min-h-screen w-full ">
    <div className="flex flex-col w-full">
        <div className="md:static fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
          <NewHeader
            userInfo={userInfo}
            isSidebarOpen={isSidebarOpen}
            toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
          />
        </div>


      <div className="flex">
      <div
        className={`transition-transform duration-300 ease-in-out md:translate-x-0 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } md:block fixed md:static top-[50px] left-0 z-50 bg-white sm:w-[15%] md:w-[10%] lg:w-[7%]`}
        style={{ height: "100vh", maxHeight: "-webkit-fill-available" }}
      >

          <NewSidebar />
        </div>

        <div className="pt-[72px] md:pt-10 p-[25px] bg-[#E5EFFF] w-full">
          <div className="pt-[25px] md:pt-0">
            <Outlet />
          </div>
          <NewFooter />
        </div>
      </div>
    </div>
  </div>
) : (
  <div className="h-screen overflow-hidden p-0 m-0">
    <Outlet />
  </div>
)}
    </div>
  );
};

export default NewDashboardLayout;
